import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import classNames from 'classnames';

import { priceFormat } from 'apps/products/utils/priceFormat';
import Icon from 'widgets/Icon/Icon';
import TextLink from 'widgets/TextLink/TextLink';
import { requestLogin } from 'utils/loginAndRegistration/login';
import wa from 'apps/analytics/services/waEventEmitter';
import { pageEventFields, pageEvents } from 'apps/products/analytics';
import PageStatistic from 'apps/analytics/components/PageStatistic';

export default class Coupon extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    campaignRedemptionCap: PropTypes.number,
    discount: PropTypes.number,
    expiration: PropTypes.string,
    isCouponApplied: PropTypes.bool.isRequired,
    router: PropTypes.object.isRequired,
  };

  handleLoggedOut = () => {
    const { router } = this.props;

    requestLogin(router);
  };

  render = () => {
    const { id: couponId, discount, expiration, campaignRedemptionCap, isCouponApplied } = this.props;
    return (
      <div className="bop-promotion">
        <PageStatistic field="PER_COUPON_ID" value={couponId} />
        <div
          className={classNames('bop-promotion__link', { 'bop-promotion__link--disabled': isCouponApplied })}
        >
          <div className="bop-promotion__content">
            <Icon name="coupon" className={classNames({ 'icon__coupon--applied': isCouponApplied })} />
            <p className="bop-promotion__title bop-promotion__title--strong bop-promotion__title--smartPass">
              {isCouponApplied ? 'Coupon applied' : 'You have one coupon'}
            </p>
            <p className="bop-promotion__description">
              {isCouponApplied
                ?
                <>
                  You&apos;ve saved {priceFormat({ value: discount })} off the total price shown.
                  <br />
                  <TextLink
                    to="/webshop/coupons.go?src=bop"
                    onClick={() => wa.triggerPageEventWithDescription(pageEvents.BOP_SHOW_ALL_COUPONS_CLICKED,
                      { [pageEventFields.PER_COUPON_ID]: couponId })}
                  >
                    View other coupons
                  </TextLink>
                </>
                :
                (
                  <>
                    Get {priceFormat({ value: discount })} off the total price shown,
                    even with offers, when you add this product. Order by {format(expiration, 'DD/MM/YYYY')}.
                    {campaignRedemptionCap && ` Only ${campaignRedemptionCap} available.`}
                  </>
                )
              }
            </p>
          </div>
        </div>
        <div className="gn-divider gn-divider--light bop-promotion__divider" />
      </div>
    );
  }
}
